import styled, { css } from 'styled-components'

import { Skeleton } from '@blade/ui-kit'
import { Separator as Separator_ } from '@root/shared/ui-kit'

export const PoolCardSkeleton: React.FC = () => (
  <Root>
    <PoolCardMainInfo>
      <Row>
        <Currencies>
          <Skeleton width={32} height={32} variant="circular" />
          <Skeleton
            width={32}
            height={32}
            variant="circular"
            css={css`
              margin-left: -8px;
            `}
          />
        </Currencies>
        <Skeleton width={72} height={16} />
      </Row>
      <Row>
        <Column>
          <Skeleton width={32} height={32} variant="circular" />
        </Column>
        <Column>
          <Skeleton width={50} height={5} />
          <Skeleton width={50} height={10} />
        </Column>
      </Row>
    </PoolCardMainInfo>
    <PoolCardMetricsSection>
      <ColumnMetrics>
        <Skeleton width={50} height={5} />
        <Skeleton width={50} height={16} />
      </ColumnMetrics>
      <Separator vertical />
      <ColumnMetrics>
        <Skeleton width={50} height={5} />
        <Skeleton width={50} height={16} />
      </ColumnMetrics>
      <Separator vertical />
      <ColumnMetrics>
        <Skeleton height={5} />
        <Skeleton height={16} />
      </ColumnMetrics>
    </PoolCardMetricsSection>
    <PoolCardAddress>
      <Column>
        <Skeleton width={130} height={10} />
      </Column>
      <Column />
      <Column>
        <Skeleton width={130} height={10} />
      </Column>
    </PoolCardAddress>
  </Root>
)

const Root = styled.div`
  border: 1px solid #ffffff09;
  background: #ffffff09;

  display: grid;
  border-radius: 10px;
`

const Row = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`

const Currencies = styled.div`
  display: inline-flex;
`

const Column = styled.div`
  display: grid;
  gap: 4px;
`

const ColumnMetrics = styled(Column)``

const Separator = styled(Separator_)`
  background: #222222;
`

const PoolCardMainInfo = styled.div`
  border-bottom: 1px solid #222222;

  display: flex;
  justify-content: space-between;

  padding-inline: 16px;
  height: 57px;
`

const PoolCardMetricsSection = styled.div`
  border-bottom: 1px solid #222222;

  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: 1fr auto 1fr auto 4fr;

  gap: 15px;
  padding-inline: 16px;
  height: 46px;
`

const PoolCardAddress = styled.div`
  display: grid;
  justify-content: space-between;
  align-items: center;

  grid-template-columns: 2fr 1fr 2fr;
  padding-inline: 16px;
  height: 40px;
  gap: 20px;
`
